import getApi from '../../api/apisauceConfig'

export const deleteUserSession = (sessionId: string) =>
  getApi().delete<void>(`/users/me/sessions/${sessionId}`)
